import React from 'react'
import AddIcon from 'components/material-symbol/icons/Add'

const MessagingFileUploadIcon = () => (
  <AddIcon htmlColor="rgba(0, 0, 0, 0.87)" />
)

export default MessagingFileUploadIcon
